const messages = [...document.querySelectorAll('.js-announcement')];

if (messages.length) {
    // Show the first announcement only to begin with.
    // Show it after a short delay so the rest of the page should be visible...
    setTimeout(function () {
        messages[0].classList.add('visible');
    }, 2000);

    // When a close link is clicked:
    // – Hide the message
    // – Create a cookie for that announcement using messageid data attr
    // – show the next message if there is one
    document.querySelectorAll('.js-announcement-close').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            var d = new Date();

            // Hide this message
            el.closest('.js-announcement').classList.remove('visible');

            // Create a cookie for this announcement to expire 2 weeks from now
            d.setTime(d.getTime() + (14 * 24 * 60 * 60 * 1000));

            document.cookie = el.dataset.messageid + "=true; expires=" + d.toUTCString() + "; path=/";

            // Show the next announcement if there is one
            messages.shift();

            if (messages.length) {
                messages[0].classList.add('visible');
            }
        });
    });
}